<template>
  <v-layout class="list-item">
    <v-checkbox v-if="showSelect" :input-value="value" class="selected-checkbox shrink mr-0 mt-0"
                color="#3ac18f" height="18px"
                @change="onSelectClicked"/>
    <v-layout @click="$emit('click')">
      <slot/>
    </v-layout>
    <v-layout class="right-area">
      <slot
        name="further-actions">
      </slot>
      <DropdownMenu v-if="actions.length > 0" :items="actions" @item-clicked="(item) => $emit(item.event, item)">
        <slot name="actions-activator">
          <v-btn class="three-dots" text height="28px" width="28px">
            <v-icon size="16">icon-dots-three-vertical</v-icon>
          </v-btn>
        </slot>
      </DropdownMenu>
      <div v-else class="placeholder"/>
    </v-layout>
  </v-layout>
</template>

<script>
  import {DropdownMenu} from "@/modules/common/components"

  export default {
    name: "ListItem",
    components: {DropdownMenu},
    props: {
      showSelect: {
        type: Boolean,
        default: false,
      },
      actions: {
        type: Array,
        default: () => [],
        validator: prop => prop.every(e => e.title && e.event),
      },
      value: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onSelectClicked(newValue) {
        this.$emit('selected-clicked', newValue);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_mixins.scss";

  .list-item {
    flex-grow: 0;
    padding: var(--size-value3);

    .selected-checkbox {
      padding-right: 4px;
    }

    .right-area {
      justify-content: flex-end;
      opacity: 0;
      transition: opacity 300ms;
      flex-grow: 0;
      @include md-and-up {
        min-width: 150px;
      }

      .three-dots {
        border-radius: 1000px;
        min-width: unset;
        padding: 0;
      }

      .placeholder {
        @include md-and-up {
          min-width: 14px;
        }
      }
    }

    &:hover {
      .right-area {
        opacity: 1;
      }
    }

    .v-btn {

      &:not(.v-btn--round).v-size--default {
        padding: 0;
        min-width: auto;
      }
    }
  }
</style>

<style lang="scss">
  .list-item {
    .selected-checkbox {
      .v-icon.v-icon {
        font-size: inherit;
      }
    }
  }
</style>
